import React from 'react';

export default function GlobeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="ic_account_language"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={props.width ?? '24'}
      height={props.height ?? '24'}
      {...props}
    >
      <rect id="Box" width="24" height="24" fill="none" />
      <g id="global" transform="translate(-171 -251)">
        <path
          id="Vector"
          d="M18,9A9,9,0,1,1,9,0,9,9,0,0,1,18,9Z"
          transform="translate(174 254)"
          fill="none"
          stroke={props.stroke ?? '#909090'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M.463,0h1a22.612,22.612,0,0,0,0,16h-1"
          transform="translate(178.869 255)"
          fill="none"
          stroke={props.stroke ?? '#909090'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0A22.612,22.612,0,0,1,0,16"
          transform="translate(185.669 255)"
          fill="none"
          stroke={props.stroke ?? '#909090'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,1V0A22.612,22.612,0,0,0,16,0V1"
          transform="translate(175 265.669)"
          fill="none"
          stroke={props.stroke ?? '#909090'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M0,1.463a22.612,22.612,0,0,1,16,0"
          transform="translate(175 258.869)"
          fill="none"
          stroke={props.stroke ?? '#909090'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <path
          id="Vector-6"
          data-name="Vector"
          d="M0,0H22V22H0Z"
          transform="translate(194 274) rotate(180)"
          fill="none"
          opacity="0"
        />
      </g>
    </svg>
  );
}
